const state = () => ({
  dialogTitle: '',
  dialogButtons: [],
  dialogLeftHeaderIcon: '',
  dialogHeaderType: 'information'
});

const getters = {
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  },
  dialogLeftHeaderIcon(state) {
    return state.dialogLeftHeaderIcon;
  },
  dialogHeaderType(state) {
    return state.dialogHeaderType;
  }
};

const mutations = {
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setDialogLeftHeaderIcon(state, payload) {
    state.dialogLeftHeaderIcon = payload;
  }
};

const actions = {
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setDialogLeftHeaderIcon({ commit }, payload) {
    commit('setDialogLeftHeaderIcon', payload);
  }
};

export const infoStep = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
